import { render, staticRenderFns } from "./QRCodeViewer.vue?vue&type=template&id=342bd41f&scoped=true&"
import script from "./QRCodeViewer.vue?vue&type=script&lang=js&"
export * from "./QRCodeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342bd41f",
  null
  
)

export default component.exports